import { HashRouter as Router, Routes, Route } from 'react-router-dom';
//------------------  AUTH
import Signup from './pages/auth/Signup';
import Auth from './pages/auth/Auth';
import Login from './pages/auth/Login';
import ForgotPassword from './pages/auth/ForgotPassword';
//------------------  CLIENT
import Dashboard from './pages/client/dashboard';
// import Documents from './pages/client/Documents';
// import Applications from './pages/client/Applications';
import ExistApplication from './pages/client/ExistApplication';
import Payment from './pages/client/Payment';
import Invoices from './pages/client/Invoices';
import AllApplications from './pages/client/AllApplications';
//------------------  ADMIN
import HomePage from "./pages/admin/HomePage"
import Leads from "./pages/admin/Leads"
import ClientHistory from "./pages/admin/ClientHistory"
import ClientTicket from "./pages/admin/ClientTicket"
import ProfileHistory from "./pages/admin/ProfileHistory"
import Employees from './pages/admin/Employees';
import AdminApplications from './pages/admin/AdminApplications';
import AgentProfile from "./pages/admin/AgentProfile"
import Marketing from "./pages/admin/Marketing"
import MarketingCampaignBuilder from "./pages/admin/MarketingCampaignBuilder"
import MarketingCampaignCreate from "./pages/admin/MarketingCampaignCreate"
import MarketingCampaigns from "./pages/admin/MarketingCampaigns"
import MarketingCampaignDetail from "./pages/admin/MarketingCampaignDetail"
//------------------  AGENT
import AgentDashboard from './pages/agent/AgentDashboard';
import AgentLeads from "./pages/agent/AgentLeads"
import AgentClientHistory from './pages/agent/AgentClientHistory';
import ApplicationLogs from './pages/agent/ApplicationLogs';
import AgentApplications from './pages/agent/AgentApplications';
import AdminDocuments from './pages/admin/AdminDocuments';
import AgentApplicationHistory from './pages/agent/AgentApplicationHistory';
import AgentProfileHistory from "./pages/agent/AgentProfileHistory"
import Settings from './pages/agent/Settings';
import AgentEmployees from './pages/agent/AgentEmployees';
import AgentEmployeeProfile from './pages/agent/AgentProfile';
import AgentDocuments from './pages/agent/AgentDocuments';
import AgentMarketing from "./pages/agent/AgentMarketing";
import AgentMarketingCampaignBuilder from "./pages/agent/AgentMarketingCampaignBuilder";
import AgentMarketingCampaignCreate from "./pages/agent/AgentMarketingCampaignCreate";
import AgentMarketingCampaigns from "./pages/agent/AgentMarketingCampaigns";
import AgentMarketingCampaignDetail from "./pages/agent/AgentMarketingCampaignDetail";
import ClientSettings from './pages/client/ClientSettings';
import AdminSettings from './pages/admin/Settings';

function App() {
  return (
    <Router>
      <Routes>
        {/* Authentication and Authorization */}
        <Route path="/" element={<Auth />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />

        {/* CLient Portal */}
        <Route path="/client" element={<Dashboard />} />
        <Route path="/client/invoices" element={<Invoices />} />
        <Route path="/client/applications" element={<AllApplications />} />
        {/* <Route path="/client/documents" element={<Documents />} /> */}
        <Route path="/client/applications/form/payment" element={<Payment />} />
        <Route path="/client/applications/form/:id" element={<ExistApplication />} />
        <Route path="/client/settings" element={<ClientSettings />} />

        {/* <Route path="/client/applications/form" element={<Applications />} /> */}

        {/* Admin Portal */}
        <Route path="/admin" element={<HomePage />} />
        <Route path="/admin/leads" element={<Leads />} />
        <Route path="/admin/employees" element={<Employees />} />
        <Route path="/admin/employees/:id" element={<AgentProfile />} />
        <Route path="/admin/documents" element={<AdminDocuments />} />
        <Route path="/admin/client-ticket" element={<ClientTicket />} />
        <Route path="/admin/settings" element={<AdminSettings />} />
        <Route path="/admin/leads/:id" element={<AdminApplications />} />
        <Route path="/admin/client-history" element={<ClientHistory />} />
        <Route path="/admin/client-history/:user" element={<ProfileHistory />} />
        <Route path="/admin/application-log" element={<ApplicationLogs />} />
        <Route path="/admin/application-log/:id" element={<AgentApplicationHistory />} />
        <Route path="/admin/marketing" element={<Marketing />} />
        <Route path="/admin/marketing/campaign-create" element={<MarketingCampaignCreate />} />
        <Route path="/admin/marketing/campaign-builder" element={<MarketingCampaignBuilder />} />
        <Route path="/admin/marketing/campaigns" element={<MarketingCampaigns />} />
        <Route path="/admin/marketing/campaigns/:id" element={<MarketingCampaignDetail />} />

        {/* Agent Portal */}
        <Route path="/agent" element={<AgentDashboard />} />
        <Route path="/agent/leads" element={<AgentLeads />} />
        <Route path="/agent/employees" element={<AgentEmployees />} />
        <Route path="/agent/employees/:id" element={<AgentEmployeeProfile />} />
        <Route path="/agent/documents" element={<AgentDocuments />} />
        <Route path="/agent/leads/:id" element={<AgentApplications />} />
        <Route path="/agent/application-log" element={<ApplicationLogs />} />
        <Route path="/agent/application-log/:id" element={<AgentApplicationHistory />} />
        <Route path="/agent/client-history" element={<AgentClientHistory />} />
        <Route path="/agent/client-history/:id" element={<AgentProfileHistory />} />
        <Route path="/agent/settings" element={<Settings />} />
        <Route path="/agent/marketing" element={<AgentMarketing />} />
        <Route path="/agent/marketing/campaign-create" element={<AgentMarketingCampaignCreate />} />
        <Route path="/agent/marketing/campaign-builder" element={<AgentMarketingCampaignBuilder />} />
        <Route path="/agent/marketing/campaigns" element={<AgentMarketingCampaigns />} />
        <Route path="/agent/marketing/campaigns/:id" element={<AgentMarketingCampaignDetail />} />

        {/* Receptionist */}



        {/* <Route path="/agent/leads/form" element={<AdminApplications />} /> */}
        <Route path="*" element={<h1>404: Page Not Found</h1>} />
      </Routes>
    </Router>
  );
}

export default App;